import React, { useState, useRef } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../config";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumber } from "react-phone-number-input";
import {addPhone_details,} from "../../Api/firebaseAPis";
import { useDispatch, useSelector } from "react-redux";
import GifLoader from "../../Responsive/Components/GifLoader";
import { signupFlask } from "../../Api/data";

const PhoneAuth2 = () => {
  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [hasFilled, setHasFilled] = useState(false);
  const phoneNumber = useSelector((state) => state.Auth).phoneNumber;
  const recaptchaVerifier = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const otpBoxReference = useRef([]);
  const GetOpt = async () => {
    if (isValidPhoneNumber(number)) {
      recaptchaVerifier.current = new RecaptchaVerifier(
        "recaptcha",
        {
          size: "invisible",
          callback: (response) => {},
        },
        auth
      );
      await signInWithPhoneNumber(auth, number, recaptchaVerifier.current)
        .then((confirmationResult) => {
          setLoading(true);
          window.confirmationResult = confirmationResult;
          setHasFilled(true);
          setLoading(false);
        })
        .catch((error) => {
          toast.error(error);
          setLoading(false);
        });
    } else {
      toast.error("something is worng");
      setLoading(false);
    }
  };

  const confirmOtp = async () => {
    setLoading(true);
    let value = parsePhoneNumber(number);
    let country = value.countryCallingCode;
    let phone = value.nationalNumber;

    if (otp.length === 6) {
      const confirmationResult = window.confirmationResult;
      await confirmationResult
        .confirm(otp.join(""))
        .then(async (result) => {
          const user = result.user;
     
          addPhone_details(user.uid, phone, country);
          const userDataToSend = {
            firstname: "",
            lastname: "",
            uid: user.uid,
            displayName: user.displayName ? user.displayName : "",
            username: "",
            email: "",
            userObj: user.metadata,
          };
          await signupFlask(userDataToSend);

          if (user.uid.length > 0) {
            dispatch({
              type: "SET_LOGGED_IN",
              isLoggedIn: true,
            });
            localStorage.setItem("uid", user.uid);
            dispatch({
              type: "SET_PHONENUMBER",
              phoneNumber: number,
            });
            localStorage.setItem("phone", number);
            setLoading(false);
            navigate("/add");
            toast.success("Phone Verified");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("User couldn't sign in (bad verification code?)");
        });
    }
    setLoading(false);
  };

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }
  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }
  return (
    <>
      {loading ? (
        <GifLoader />
      ) : (
        <>
          {!hasFilled ? (
            <>
              <div className="flex w-full h-screen items-center justify-between flex-col gap-3 bg-gray-50 dark:bg-gray-900 ">
                <div className="w-full mx-auto flex gap-3 flex-col items-center">
                  <h2 className="flex flex-col gap-1">
                    <span className="text-white font-semibold text-2xl capitalize ">
                      Your Phone Number
                    </span>
                    <span className="text-white font-normal text-sm capitalize ">
                      Enter your phone number to get started.
                    </span>
                  </h2>

                  <PhoneInput
                    placeholder="Enter phone number"
                    className="bg-[#141414] p-4 mt-3 rounded-lg shadow-lg w-[90%] h-1/4 "
                    defaultCountry="US"
                    value={number}
                    type="tel"
                    onChange={setNumber}
                  />
                </div>
                <button
                  onClick={GetOpt}
                  className="bg-blue-500   w-[80%] hover:bg-blue-700 my-4 text-white font-bold py-2 px-4 rounded transform active:scale-75 transition-transform"
                >
                  Submit
                </button>
              </div>
              <div id="recaptcha"></div>
            </>
          ) : (
            <>
            <div className="flex w-full h-screen items-center justify-between flex-col gap-3 bg-gray-50 dark:bg-gray-900  ">
              <div className="">
              <h2 className="text-white font-semibold text-2xl capitalize ">
                Verify OTP
              </h2>

              <div className="flex items-center gap-1">
                {otp &&
                  otp.map((digit, index) => (
                    <input
                      key={index}
                      value={digit}
                      max={1}
                      type="tel"
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                      ref={(reference) =>
                        (otpBoxReference.current[index] = reference)
                      }
                      className={`border w-10 h-10 text-white p-3 mx-1 rounded-md block bg-black focus:border-2 focus:outline-none appearance-none`}
                    />
                  ))}
              </div>
              </div>
              <button
                onClick={confirmOtp}
                className="bg-blue-500 w-[80%] hover:bg-blue-700 my-4 text-white font-bold py-2 px-4 rounded transform active:scale-75 transition-transform"
              >
                Confirm
              </button>

            </div>
              <div id="recaptcha"></div>
            </>
          )}

          <Toaster position="top-center" reverseOrder={false} />
        </>
      )}
    </>
  );
};

export default PhoneAuth2;
